const getters = {
  // Have to do some magic coz <3 IE
  groupsArray: ({ groups }) => Object.keys(groups).map(key => groups[key]),

  groupsSimple: ({ groups }) => Object.keys(groups).map(key => {
    return {
      label: groups[key].slug,
      value: groups[key].id
    }
  }),

  getById: ({ groups }) => (id) => {
    return groups[id]
  },

  byKey: ({ groups }) => key => groups[key],

  bySlug: ({ groups }) => slug => {
    var found = {}
    Object.keys(groups).forEach(groupKey => {
      if (groups[groupKey].slug === slug) {
        found = groups[groupKey]
      }
    })
    return found
  },

  active: ({ active }) => active,

  newGroup: ({ newGroup }) => newGroup
}

export default getters
